import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Dimmer, Loader } from 'semantic-ui-react';
import * as LocalStorageManager from '../../util/StorageManager';
import { isDefined } from '../../util/Common';
import AuthService from '../../util/Authenticate';
import HttpService from '../../util/HttpService';

class ExternalLogin extends Component {
    
    constructor(){
        super();
        this.state = {
            message: '',
            success: false
        }
    }

    componentDidMount(){
        /* Parametros declarados no Router */
        const { idtCliente, origem } = this.props.match.params;
        this.buscarDadosEmpresa(idtCliente, origem);
    }

    buscarDadosEmpresa = (idtCliente, origem) => {
        if(isDefined(idtCliente)){
            LocalStorageManager.clearEmpresaState();
            LocalStorageManager.clearUserState();
            this.setState({ message: 'Buscando empresa' });

            // Buscar logo, nome, cores, etc.
            HttpService.call(
                '',
                'empresa',
                [
                    idtCliente,
                    origem
                ],
                (dadosEmpresa) => {
                    if(isDefined(dadosEmpresa)){
                        LocalStorageManager.setEmpresa(dadosEmpresa);
    
                        if(isDefined(dadosEmpresa.origem)){
                            // Seta os dados da empresa selecionada
                            LocalStorageManager.setOrigem({ idt: dadosEmpresa.origem, nome: dadosEmpresa.razaoSocial });
                        }
                    }
                    
                    /* Parametro :idtAutenticacao declarado no Router */
                    const { idtAutenticacao } = this.props.match.params;
                    this.autenticar(idtAutenticacao);
                }
            )
        }
    }

    autenticar = (idtAutenticacao) => {
        if(LocalStorageManager.isEmpresaSet() && isDefined(idtAutenticacao)){
            this.setState({ message: 'Autenticando' });
            
            AuthService.authenticate(
                idtAutenticacao, 
                (userData) => {
                    LocalStorageManager.setLoggedUser(userData);
                    this.setState({ success: true });
                }
            );
        }else{
            this.setState({ success: true });
        }
    }

    render() {
        const { success, message } = this.state;

        return (
            success ? (
                <Redirect to={{
                    pathname: '/main'
                }}/>
            ) : (
                <Dimmer active page>
                    <Loader size='big' indeterminate>
                        { message }
                    </Loader>
                </Dimmer>
            )
        )
    }
}

export default withRouter(ExternalLogin);


// WEBPACK FOOTER //
// ./src/views/ExternalLogin/index.js